<template>
  <div class="container-table-indicadores">
    <q-card-section>
      <q-table
        data-cy="indicadores-table"
        :title=title
        :title-class=titleclass
        :data="indicadores"
        :columns="columns"
        row-key="id"
        :pagination.sync="pagination"
        :loading="isLoading"
        :selection="showSelection ? 'multiple' : 'none'"
        :selected="selected"
        binary-state-sort
      >
      <!-- ID Proveedor -->
      <template v-slot:body-cell-idProveedor="props">
          <q-td key="idProveedor" :props="props">
              {{ props.row.idProveedor }}
          </q-td>
        </template>
        <template
          v-if="showSelection"
          v-slot:body-cell-estado="props"
        >
          <q-td data-cy="estado" :props="props" key="estado">
            {{ props.selected ? "Visible" : "" }}
          </q-td>
        </template>
        <template v-slot:body-cell-fechaCreacion="props">
          <q-td key="fechaCreacion" :props="props">
            {{ props.row.fechaCreacion | shortDate }}
          </q-td>
        </template>
        <template v-slot:body-cell-editar="props">
          <q-td key="editar" :props="props">
            <q-icon
              data-cy="bEditCity"
              name="o_create"
              style="
                color: rgba(0, 0, 0, 0.54);
                font-size: 24px;
                cursor: pointer;
              "
              @click="triggerEdit(props.row)"
            />
          </q-td>
        </template>
        <template v-slot:body-cell-eliminar="props">
          <q-td key="eliminar" :props="props">
            <q-icon
              name="o_delete"
              style="
                color: rgba(0, 0, 0, 0.54);
                font-size: 24px;
                cursor: not-allowed;
              "
            />
          </q-td>
        </template>
        <template
          v-if="showSelection"
          v-slot:body-selection="props"
        >
          <q-checkbox
            data-cy="checkBox"
            color="primary"
            v-model="props.selected"
            @input="(v) => saveValue(v, props.row)"
            :disable="disableCheckBox"
          >
          </q-checkbox>
        </template>
        <template
          v-if="showSelection"
          v-slot:header-selection="props"
        >
          <q-checkbox
            color="primary"
            v-model="props.selected"
            @input="(v) => selectAll(v, props.row)"
            :disable="disableCheckBox"
          >
          </q-checkbox
        ></template>
      </q-table>
    </q-card-section>
    <PopUpEdicionIndicador v-if="showPopUpEdicionIndicador" v-model="showPopUpEdicionIndicador" :datosIndicador="datosIndicador" @saveDetalleIndicador="saveDetalleIndicador"/>
  </div>
</template>
<script>
import Message from '@/components/shared/mixins/Message.js';
import { QTable, QTd, QCardSection } from 'quasar';
import * as types from '@/storeModules/NGUD/types';
import { mapGetters } from 'vuex';
import PopUpEdicionIndicador from '@/components/Indicadores/components/PopUpEdicionIndicador.vue';
import Loading from '@/components/shared/mixins/Loading.js';

export default {
  mixins: [Message, Loading],
  components: {
    QTable,
    QTd,
    QCardSection,
    PopUpEdicionIndicador
  },
  props: {
    dataCiudades: Array,
    isLoading: Boolean,
    showSelection: {
      type: Boolean,
      default: () => false
    },
    indicadoresSelected: {
      type: Array,
      default: () => []
    },
    title: {
      required: false,
      type: String,
      default: () => ''
    },
    titleclass: {
      required: false,
      type: String,
      default: () => 'titleCard'
    }
  },
  computed: {
    ...mapGetters({
      indicadores: types.ALL_INDICADORES,
      indicadorCiudad: types.INDICADOR_CIUDAD
    }),
    disableCheckBox () {
      return false;
    }
  },
  created () {
    this.showLoading();
    this.$store
      .dispatch(types.ACTION_GET_ALL_INDICADORES)
      .then(() => {
        this.hideLoading();
      })
      .catch(() => {
        this.hideLoading();
      });
  },
  data () {
    return {
      pagination: {
        rowsPerPage: 20
      },
      selected: [],
      showPopUpEdicionIndicador: false,
      datosIndicador: {},
      columns: [
        {
          name: 'idProveedor',
          label: 'ID Proveedor',
          align: 'left',
          field: 'idProveedor',
          sortable: true,
          sort: (a, b) => parseInt(a) - parseInt(b)
        },
        {
          name: 'name',
          label: 'Indicador',
          align: 'left',
          field: 'name',
          sortable: true,
          sort: (a, b) => b.localeCompare(a)
        },
        {
          name: 'fechaCreacion',
          label: 'Fecha de Creación',
          align: 'left',
          field: 'fechaCreacion',
          sortable: true
        },
        {
          name: 'editar',
          label: 'Editar',
          align: 'center',
          field: '',
          sortable: false
        },
        {
          name: 'eliminar',
          label: 'Eliminar',
          align: 'center',
          field: '',
          sortable: false
        }
      ]
    };
  },
  methods: {
    saveValue (action, item) {
      action ? this.selected.push({ id: item.id }) : this.selected = this.selected.filter((val) => { return item.id !== val.id; });
      this.updateSelectItems();
    },
    selectAll (action) {
      action ? this.indicadores.map((val) => { this.selected.push({ id: val.id }); }) : this.selected = [];
      this.updateSelectItems();
    },
    updateSelectItems () {
      this.$emit('refreshSelectedItems', { selected: this.selected });
    },
    async triggerEdit (row) {
      this.showLoading();
      await this.$store.dispatch(types.ACTION_GET_INDICADOR, { idIndicador: row.id }).then(async response => {
        this.hideLoading();
        this.datosIndicador = response.data;
        this.showPopUpEdicionIndicador = true;
      }).catch(() => { this.hideLoading(); });
    },
    async saveDetalleIndicador (newDato) {
      this.showLoading();
      await this.$store.dispatch(types.ACTION_SAVE_INDICADOR, { idIndicador: newDato.idIndicador, dataIndicador: newDato }).then(async response => {
        this.hideLoading();
        this.showPopUpEdicionIndicador = false;
      }).catch(() => { this.hideLoading(); });
    }
  },
  watch: {
    indicadorCiudad: {
      handler: function () {
        this.selected = [];
        if (
          this.indicadorCiudad &&
          Object.entries(this.indicadorCiudad).length > 0
        ) {
          this.setSelectedItems();
        }
      },
      immediate: true
    },
    indicadoresSelected: {
      handler: function (val) {
        this.selected = val.map(n => { return { id: n }; });
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
.container-table-indicadores {
  &::v-deep {
    .q-table__card {
      box-shadow: none;
    }

    .q-card__section--vert {
      padding: 0 !important;
    }
    .titleCardEdicion{
      margin: 10px 282px 0px 15px;
      font-family: DINPro;
      font-weight: 500;
      font-size: 20px;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.29px;
      color: #000000;
    }
  }
}
</style>
